// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 977 ? "orderCreate" : chunkId) + "." + {"381":"b2cbed00","977":"9e7abdcd"}[chunkId] + ".js";
};